export default __webpack_public_path__ + "static/media/085-spider.64580dfa.svg";